<template>
  <!-- 課程詳細頁面 -->
  <section class="course-detail" v-if="isReedy">
    <div class="container">
      <!-- 課程標題區塊 -->
      <div class="course-detail__header">
        <h1 class="course-detail__title">{{ data.courseName }}</h1>
      </div>

      <!-- 主要內容區 -->
      <div class="course-detail__main">
        <!-- 左側：影片播放區 -->
        <div class="course-detail__video-section">
          <div class="course-video">
            <div
              class="course-video__player"
              :style="{
                backgroundImage: 'url(' + data.contentImagePath + ')',
              }"
            >
              <iframe
                v-if="data.courseYoutubeUrl"
                class="course-video__iframe"
                :src="`https://www.youtube.com/embed/${data.courseYoutubeUrl}`"
                frameborder="0"
                allow="accelerometer;
                autoplay;
                clipboard-write;
                encrypted-media;
                gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>

        <!-- 右側：課程購買資訊 -->
        <div class="course-detail__sidebar">
          <div class="course-purchase">
            <!-- 價格區塊 -->
            <div class="course-purchase__header">
              <div class="course-purchase__header-content">
                <div class="course-purchase__sale-badge">
                  <span class="course-purchase__sale-text">{{ $t('course.label.salePrice') }}</span>
                </div>
                <div class="course-purchase__price-row">
                  <div class="course-purchase__price-main">
                    <span class="course-purchase__price-currency">{{ $t('common.currency.ntd') }}</span>
                    <span class="course-purchase__price-value">{{ data.coursePrice | toCurrency }}</span>
                  </div>
                  <div class="course-purchase__price-original">
                    <span class="course-purchase__original-value">
                      {{ $t('common.currency.ntd') }}
                      {{ data.courseOriPrice | toCurrency }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- 課程詳細資訊 -->
            <div class="course-purchase__details">
              <ul class="course-purchase__details-list">
                <li class="course-purchase__details-item">
                  <span class="course-purchase__details-label">
                    <i class="icon-clock"></i>
                    {{ $t('course.label.viewPeriod') }}
                  </span>
                  <span class="course-purchase__details-value">
                    {{ data.courseViewStartDate | toTaipei | moment('YYYY-MM-DD') }} -
                    {{ data.courseViewEndDate | toTaipei | moment('YYYY-MM-DD') }}
                  </span>
                </li>

                <li class="course-purchase__details-item">
                  <span class="course-purchase__details-label">
                    <i class="icon-book"></i>
                    {{ $t('course.label.subject') }}
                  </span>
                  <span class="course-purchase__details-value">{{ AllSubject }}</span>
                </li>

                <li class="course-purchase__details-item" v-if="data.courseType === 1">
                  <span class="course-purchase__details-label">
                    <i class="icon-list"></i>
                    {{ $t('course.label.lessons') }}
                  </span>
                  <span class="course-purchase__details-value">
                    {{ Classes }} {{ $t('course.unit.lessons') }}
                  </span>
                </li>
              </ul>
            </div>

            <!-- 加入購物車按鈕 -->
            <div class="course-purchase__action">
              <button
                class="course-purchase__btn"
                @click.prevent="AddToCar(data.courseId)"
              >
                <span class="course-purchase__btn-icon">🛒</span>
                <span class="course-purchase__btn-text">{{ $t('common.button.addToCart') }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 課程相關資訊 -->
      <div class="course-detail__content">
        <CourseInfo
          :courseInfo="data"
          :learning="false"
        />
      </div>
    </div>
  </section>
</template>

<script>
import CourseInfo from '@/components/CourseInfo.vue';
import { GetBuyCourseContent } from '@/api/BuyCourseApi';

export default {
  props: ['currentPage'],
  components: {
    CourseInfo,
  },
  data() {
    // 建立你的初始化 model data
    return {
      isReedy: false,
      data: {
        courseId: 0,
        courseName: '',
        examId: 0,
        examName: '',
        categoryId: 0,
        categoryName: '',
        roomId: 0,
        roomName: '',
        courseOriPrice: 0,
        coursePrice: 0,
        courseContent: '',
        contentImagePath: '',
        courseYoutubeUrl: '',
        courseViewStartDate: this.$moment(new Date('9999/12/31')),
        courseViewEndDate: this.$moment(new Date('9999/12/31')),
        classRoomList: [
          {
            subjectId: 0,
            subjectName: '',
            buyCourseClassRoomList: [
              {
                classId: 0,
                className: '',
                teacherId: 0,
                teacherName: '',
              },
            ],
          },
        ],
      },
      CourseTypeName: '',
      AllSubject: '',
      // optionalClassInfo: [],
      Classes: 0,
    };
  },
  created() {
    this.GetBuyCourseContent();
  },
  methods: {
    GetBuyCourseContent() {
      const { id } = this.$route.params;
      GetBuyCourseContent({ courseId: id }).then((response) => {
        if (response.data.statusCode === 0) {
          try {
            this.data = response.data.data;
            this.$emit('update:currentPage', [
              {
                name: '',
                title: this.data.examName,
                path: '/course',
              },
              {
                name: 'ClassRoom',
                title: this.data.categoryName,
                path: '/course/classRoom',
                params: {
                  examId: this.data.examId,
                  categoryId: this.data.categoryId,
                },
              },
              {
                name: '',
                title: this.data.courseName,
                path: '',
              },
            ]);
            this.Classes = this._.reduce(
              this.data.classRoomList,
              (sum, item) => sum + item.buyCourseClassRoomList.length,
              0,
            );
            this.CourseTypeName = `${this.data.courseTypeName}課程`;
            // 取得 自選課程的科目
            this.AllSubject = this._.map(this.data.classRoomList, 'subjectName');
            if (this.data.courseType === 2) {
              // console.log(
              //   this._.flatMap(this.data.optionalClassRoomList,
              //     (item) => item.optionalClassRoomList.map((item2) => item2.subjectName)),
              // );

              // this.AllSubject.push(...this.data.optionalClassRoomList
              //   .map((item) => item.optionalSubjectName));

              this.AllSubject.push(...this._.flatMap(this.data.optionalClassRoomList,
                (item) => item.optionalClassRoomList.map((item2) => item2.subjectName)));
            }

            this.AllSubject = this._.chain(this.AllSubject).uniqBy().join('， ').value();

            this.isReedy = true;
          } catch (error) {
            this.$router.replace('/error');
          }
        } else this.$router.replace('/error');
      });
    },
    AddToCar(id) {
      this.$bus.$emit('addShoppingCart', id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

// 課程詳細頁面
.course-detail {
  min-height: 100vh;

  // 頁面標題區塊
  &__header {
    margin-bottom: 24px;

    @media (max-width: $breakpoint-md) {
      margin-bottom: 20px;
    }

    @media (max-width: $breakpoint-sm) {
      margin-bottom: 16px;
    }
  }

  &__title {
    font-size: 28px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
    line-height: 1.4;
    font-family: var(--font-family-bold);

    @media (max-width: $breakpoint-md) {
      font-size: 24px;
    }

    @media (max-width: $breakpoint-sm) {
      font-size: 20px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 18px;
    }
  }

  // 主要內容區
  &__main {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 32px;
    margin-bottom: 48px;

    @media (max-width: $breakpoint-lg) {
      grid-template-columns: 1fr 320px;
      gap: 24px;
    }

    @media (max-width: $breakpoint-md) {
      grid-template-columns: 1fr;
      gap: 24px;
      margin-bottom: 32px;
    }

    @media (max-width: $breakpoint-sm) {
      gap: 20px;
      margin-bottom: 24px;
    }

    @media (max-width: $breakpoint-xs) {
      gap: 16px;
      margin-bottom: 20px;
    }
  }

  &__video-section {
    min-height: 0;
  }

  &__sidebar {
    min-height: 0;
  }

  &__content {
    width: 100%;
    margin-top: 24px;
  }
}

// 課程影片播放器
.course-video {
  background: var(--background-white);
  border-radius: var(--border-radius-lg);
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--border-light);

  @media (max-width: $breakpoint-sm) {
    border-radius: var(--border-radius-base);
  }

  &__player {
    position: relative;
    padding-bottom: 56.25%; // 16:9 比例
    height: 0;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    background-color: var(--background-dark);
  }

  &__iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
}

// 課程購買卡片
.course-purchase {
  position: sticky;
  top: 90px;
  background: var(--background-white);
  border-radius: var(--border-radius-lg);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid var(--border-light);
  display: flex;
  flex-direction: column;
  height: fit-content;

  @media (max-width: $breakpoint-md) {
    position: relative;
    top: 0;
  }

  @media (max-width: $breakpoint-sm) {
    border-radius: var(--border-radius-base);
  }

  // 頂部標題區
  &__header {
    padding: 16px 18px;
    border-bottom: 1px solid var(--border-extra-light);

    @media (max-width: $breakpoint-md) {
      padding: 14px 16px;
    }

    @media (max-width: $breakpoint-sm) {
      padding: 12px 14px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 10px 12px;
    }
  }

  &__header-content {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    @media (max-width: $breakpoint-md) {
      align-items: flex-start;
      gap: 10px;
    }

    @media (max-width: $breakpoint-sm) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  &__sale-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 32px;
    border: 3px solid #dc3545;
    color: #dc3545;
    border-radius: 30px;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.5px;
    flex-shrink: 0;

    @media (max-width: $breakpoint-lg) {
      font-size: 16px;
      padding: 4px 24px;
      border-width: 2px;
    }

    @media (max-width: $breakpoint-md) {
      font-size: 14px;
      padding: 4px 16px;
    }

    @media (max-width: $breakpoint-sm) {
      font-size: 12px;
      padding: 3px 12px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 11px;
      padding: 2px 10px;
    }
  }

  &__price-row {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    gap: 4px;
    flex-wrap: wrap;
  }

  &__price-main {
    display: flex;
    align-items: baseline;
    gap: 4px;
  }

  &__price-currency {
    font-size: 18px;
    font-weight: 700;
    color:#dc3545;
    font-family: var(--font-family-bold);

    @media (max-width: $breakpoint-lg) {
      font-size: 16px;
    }

    @media (max-width: $breakpoint-md) {
      font-size: var(--font-size-base);
    }

    @media (max-width: $breakpoint-sm) {
      font-size: var(--font-size-sm);
    }
  }

  &__price-value {
    font-size: 32px;
    font-weight: 800;
    color: #dc3545;
    line-height: 1;
    font-family: var(--font-family-bold);

    @media (max-width: $breakpoint-lg) {
      font-size: 32px;
    }

    @media (max-width: $breakpoint-md) {
      font-size: 28px;
    }

    @media (max-width: $breakpoint-sm) {
      font-size: 24px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 20px;
    }
  }

  &__price-original {
    display: flex;
    align-items: center;
  }

  &__original-value {
    font-size: var(--font-size-sm);
    font-weight: 500;
    color: var(--text-placeholder);
    text-decoration: line-through;

    @media (max-width: $breakpoint-sm) {
      font-size: var(--font-size-sm);
    }

    @media (max-width: $breakpoint-xs) {
      font-size: var(--font-size-xs);
    }
  }

  // 按鈕區域
  &__action {
    padding: 16px 18px;
    background: var(--background-white);
    border-top: 1px solid var(--border-extra-light);

    @media (max-width: $breakpoint-md) {
      padding: 14px 16px;
    }

    @media (max-width: $breakpoint-sm) {
      padding: 12px 14px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 10px 12px;
    }
  }

  &__btn {
    width: 100%;
    padding: 11px 20px;
    font-size: var(--font-size-base);
    font-weight: 700;
    color: var(--text-white);
    background: linear-gradient(135deg, var(--primary-color) 0%, #0090c9 100%);
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: all var(--transition-base);
    letter-spacing: 0.3px;
    position: relative;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 171, 235, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
      transition: left 0.5s;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0, 171, 235, 0.4);

      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 6px rgba(0, 171, 235, 0.3);
    }

    @media (max-width: $breakpoint-md) {
      padding: 10px 18px;
      font-size: var(--font-size-sm);
      gap: 6px;
    }

    @media (max-width: $breakpoint-sm) {
      padding: 9px 16px;
      font-size: var(--font-size-sm);
      gap: 5px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 8px 14px;
      font-size: var(--font-size-xs);
      gap: 4px;
    }
  }

  &__btn-icon {
    font-size: var(--font-size-base);
    line-height: 1;

    @media (max-width: $breakpoint-md) {
      font-size: 15px;
    }

    @media (max-width: $breakpoint-sm) {
      font-size: 14px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: 13px;
    }
  }

  &__btn-text {
    line-height: 1;
  }

  // 詳細資訊區
  &__details {
    padding: 20px;
    background: var(--background-light);

    @media (max-width: $breakpoint-md) {
      padding: 18px;
    }

    @media (max-width: $breakpoint-sm) {
      padding: 16px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 14px;
    }
  }

  &__details-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__details-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 12px 0;
    border-bottom: 1px solid var(--border-lighter);

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }

    @media (max-width: $breakpoint-sm) {
      padding: 10px 0;
      gap: 5px;
    }

    @media (max-width: $breakpoint-xs) {
      padding: 8px 0;
      gap: 4px;
    }
  }

  &__details-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: var(--font-size-base);
    font-weight: 700;
    color: var(--text-primary);

    i {
      font-size: var(--font-size-base);
      color: var(--primary-color);
    }

    @media (max-width: $breakpoint-sm) {
      font-size: var(--font-size-sm);
      gap: 6px;

      i {
        font-size: var(--font-size-sm);
      }
    }

    @media (max-width: $breakpoint-xs) {
      font-size: var(--font-size-xs);
      gap: 5px;

      i {
        font-size: var(--font-size-xs);
      }
    }
  }

  &__details-value {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    line-height: 1.6;
    padding-left: 24px;

    @media (max-width: $breakpoint-sm) {
      font-size: var(--font-size-sm);
      padding-left: 20px;
    }

    @media (max-width: $breakpoint-xs) {
      font-size: var(--font-size-xs);
      padding-left: 18px;
    }
  }
}

// 純 CSS 圖示
.icon-clock,
.icon-book,
.icon-list {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: relative;
  flex-shrink: 0;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.icon-clock {
  &::before {
    width: 14px;
    height: 14px;
    border: 2px solid currentColor;
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 50%;
    width: 2px;
    height: 6px;
    background: currentColor;
    transform: translateX(-50%);
  }
}

.icon-book {
  &::before {
    width: 12px;
    height: 14px;
    border: 2px solid currentColor;
    border-radius: 1px;
  }

  &::after {
    content: '';
    position: absolute;
    top: 5px;
    left: 50%;
    width: 8px;
    height: 2px;
    background: currentColor;
    transform: translateX(-50%);
  }
}

.icon-list {
  &::before {
    width: 14px;
    height: 2px;
    background: currentColor;
    box-shadow: 0 -4px 0 currentColor, 0 4px 0 currentColor;
  }
}
</style>
